<template>
    <div class="modal-overlay">
      <div class="modal-container">
        <div class="modal-body">
          <div class="modal-header">
            <img src="../../assets/weight-short.png"/>
            <h3>{{ selectedExercise.title.toUpperCase() }}</h3>
            <i class="fas fa-times" @click="closeModal()"></i>
          </div>
          <div class="modal-row">
            <div id="shrink" class="modal-input">
              <label class="top-stat">COMPLETED</label>
              <span class="top-stat-value">{{ getValue('completed') }}</span>
            </div>
          </div>
          <div class="modal-row">
            <div class="modal-input">
              <label>Primary</label>
              <span>{{ getValue('muscles') }}</span>
            </div>
            <div class="modal-input">
              <label>Type</label>
              <span>{{ getValue('exercise_type') }}</span>
            </div>
          </div>
          <div class="modal-row">
            <div class="modal-input">
              <label>Secondary</label>
              <span>{{ getValue('secondary_muscles', true) }}</span>
            </div>
            <div class="modal-input">
              <label>Difficulty</label>
              <span>{{ getValue('difficulty') }}</span>
            </div>
          </div>
          <div class="modal-row">
            <div class="modal-input">
              <label>Keywords</label>
              <span>{{ getValue('keywords') }}</span>
            </div>
            <div class="modal-input">
              <label>Equipment</label>
              <span>{{ getValue('equipment') }}</span>
            </div>
          </div>
          <div class="modal-row">
            <div class="modal-input">
              <label>Description</label>
              <span>{{ selectedExercise.exercise_details || '-' }}</span>
            </div>
          </div>

                    <div class="modal-row">
            <div class="video-input">
              <p>Male Video:</p>
              <div class="video-option dropbox default">
                <input
                  type="file"
                  @change="
                    filesChange($event.target.files, 'maleVideo');
                    fileCount = $event.target.files.length;
                  "
                  accept="video/mp4"
                  class="input-file"
                />
                <div v-if="!maleVideo && !maleVideoThumbnailUrl" class="default-vid">
                  <i class="fas fa-play"></i>
                </div>
                <div class="preview-vid" v-else>
                  <i class="fas fa-times" @click="deleteVideo('maleVideo');"></i>
                  <video
                    autoplay playsinline
                    :key="maleVideoThumbnailUrl"
                    width="320" height="240" controls>
                      <source :src="maleVideoThumbnailUrl" type="video/mp4">
                      Your browser does not support the video tag.
                  </video>
                </div>
              </div>
            </div>

            <div class="video-input">
              <p>Female Video:</p>
              <div class="video-option dropbox default">
                <input
                  type="file"
                  @change="
                    filesChange($event.target.files, 'femaleVideo');
                    fileCount = $event.target.files.length;
                  "
                  accept="video/mp4"
                  class="input-file"
                />
                <div v-if="!femaleVideo && !femaleVideoThumbnailUrl" class="default-vid">
                  <i class="fas fa-play"></i>
                </div>              
                <div class="preview-vid" v-else>
                  <i class="fas fa-times" @click="deleteVideo('femaleVideo');"></i>
                  <video
                    autoplay playsinline
                    :key="femaleVideoThumbnailUrl"
                    width="320" height="240" controls>
                      <source :src="femaleVideoThumbnailUrl" type="video/mp4">
                      Your browser does not support the video tag.
                  </video>
                </div>
              </div>
            </div>
          </div>  
        </div>
        <div class="modal-footer">
          <button class="secondary-btn-dark" @click="editExercise()">
            <i class="fas fa-plus"></i>
            EDIT EXERCISE
          </button>
          <button @click="deleteExercise()" class="delete-btn">
            DELETE EXERCISE
          </button>
        </div>
      </div>
    </div>
</template>

<script>
import { loadVideos, updateExerciseVideos, deleteExercise } from '@/api/requests';

export default {
  name: "ExerciseDetailModal",

  data() {
    return {
      maleVideo: null,
      maleVideoThumbnailUrl: '',
      deleteMaleVideo: false,
      femaleVideo: null,
      femaleVideoThumbnailUrl: '',
      deleteFemaleVideo: false,
    };
  },

  mounted() {
    this.loadVideos();
  },

  methods: {
    loadVideos() {
      loadVideos(this.selectedExercise.id).then(response => {
        if (response.data?.male_video) {
          this.maleVideoThumbnailUrl = this.url + response.data?.male_video
        }
        if (response.data?.female_video) {
          this.femaleVideoThumbnailUrl = this.url + response.data?.female_video
        }
      });
    },

    deleteVideo(type) {
      let formData = new FormData();
      if (type == 'maleVideo') {
        formData.append('delete_male_video', true);
        this.maleVideoThumbnailUrl = ''; this.maleVideo = null;
      } else {
        formData.append('delete_female_video', true);
        this.femaleVideoThumbnailUrl = ''; this.femaleVideo = null;
      }

      updateExerciseVideos(this.selectedExercise.id, formData).then(() => {
        this.$toasted.global.app_success({
          message: "Video has been updated."
        });
      });
    },

    saveVideo(type) {
      let formData = new FormData();
      let error = false;
      if (type == 'maleVideo') {
        if (this.maleVideo != null) {
          formData.append(
            "male_video",
            this.maleVideo,
            this.maleVideo.name
          );
        } else {
          error = true;
        }
      }

      if (type == 'femaleVideo') {
        if(this.femaleVideo != null) {
          formData.append(
            "female_video",
            this.femaleVideo,
            this.femaleVideo.name
          );
        } else {
          error = true;
        }
      }

      if (!error) {
        updateExerciseVideos(this.selectedExercise.id, formData).then(() => {
          this.$toasted.global.app_success({
            message: "Video has been updated."
          });
        });
      } else {
        this.$toasted.global.app_error({
          message: "Video failed to upload."
        });
      }
    },

    filesChange(fileList, type) {
      if (type === 'maleVideo') {
        this.maleVideo = fileList[0];
        this.deleteMaleVideo = false;
        this.saveVideo(type);
      } else if (type === 'femaleVideo') {
        this.femaleVideo = fileList[0];
        this.deleteFemaleVideo = false;
        this.saveVideo(type);
      }
    },
    
    getValue(attribute) {
      if (attribute === 'secondary_muscles') {
        if (this.selectedExercise[attribute]) {
          const muscles = JSON.parse(this.selectedExercise[attribute]);
          return muscles.map(muscle => muscle.label).join(', ');
        }
        return '-';
      } else if (attribute === 'keywords') {
        let value = this.selectedExercise[attribute];
        if (value) {
          value = value.replace("{", "");
          value = value.replace("}", "");
          value = value.replaceAll("\"", "");
        }
        return value !== '' ? value : '-';
      } else {
        return this.selectedExercise[attribute] ? this.selectedExercise[attribute] : '-';
      }
    },

    closeModal() {
      this.$store.dispatch('exercise/exerciseDetailsClosed');
    },

    deleteExercise() {
      if (confirm('Are you sure you want to delete this exercise?')) {
        deleteExercise(this.selectedExercise.id).then(() => {
          this.$toasted.global.app_success({
            message: "Exercise has been deleted."
          });
          this.$store.dispatch('reloadTable');
          this.closeModal();
        });
      }
    },

    editExercise() {
      this.$store.dispatch('exercise/editExerciseClicked', this.selectedExercise);
    }

  },

  computed: {
    selectedExercise() {
      return this.$store.state.exercise.selectedExercise;
    },

    url() {
      let url = window.location.origin;
      if (url === "http://localhost:8080") {
        url = "http://localhost:3000";
      }
      return url;
    },
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/css/variables";
@import "@/assets/css/internal";

.modal-overlay {
  position: fixed;
  top: 0;
  width: 100%;
  height: 100%;
  background: rgba(0,0,0,0.50);
  z-index: 100;
  left: 0;

  .modal-container {
    background: $sec0;
    width: 40%;
    margin-left: 30%;
    margin-top: 150px;
    box-shadow: 0px 0px 40px rgba(0, 0, 0, 0.55);

    .modal-body {
      background: $sec0;
      padding: $spacing-base;

      .modal-header {
        display: flex;
        align-items: center;
        padding-bottom: $spacing-base;

        h3 {
          color: #FFF;
          padding: 0;
          margin: 0;
          font-size: $font-size-medium;
          display: inline-block;
          flex: 1;
        }
        img {
          display: inline-block;
          margin-right: $spacing-small;
        }
        i {
          color: $sec4;
          cursor: pointer;
        }
      }

      .modal-row {
        display: flex;
        margin-bottom: $spacing-base;
        gap: $spacing-small;
        label {
          display: block;
          color: $sec6;
          font-size: $font-size-x-small;
          font-weight: bold;
          text-transform: uppercase;
          margin-bottom: 2px;
        }

        span {
          color: $sec4;
          font-size: $font-size-small;
        }

        .modal-input {
          width: 100%; 

          .top-stat {
            font-size: $font-size-small;
            font-weight: 500;
            color: $sec5;
          }

          .top-stat-value {
            font-size: 24px;
            font-weight: bold;
            color: #fff;
          }
        }
      }
    }
  }
}

.video-option {
  margin-left: 0;
}

.video-input {
  flex: 0;

  p {
    font-weight: 500;
    font-size: 14px;
    color: #BDBDBD;
    padding: 0;
    margin: 0;
    margin-bottom: 4px;
  }
}

.dropbox {
  border-radius: 0;
  width: 130px;
  height: 130px;
}

.default {
  float: left;
  background: $sec0;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid $sec5;
  overflow: hidden;

  img {
    width: 20px;
    height: 20px;
    display: inline-block;
  }
}
.default-vid { 
  display: flex;
  align-items: center;
  justify-content: center;

  span {
    font-size: $font-size-base;
    color: $sec4;
    font-weight: bold;
  }

  i {
    font-size: $font-size-base;
    color: $sec4;
    font-weight: bold;
  }
}

.preview-vid {
  height: 130px;
  width: 130px;
  position: relative;
  display: flex;
  justify-content: center;

  i {
    right: 5px;
    position: absolute;
    z-index: 1;
    top: 5px;
  }
}

#preview {
  width: 100%;
  height: 100%;
}

#shrink {
  width: auto;
  margin-right: $spacing-base * 2;
}

.modal-footer {
  background: $sec1;
  padding: $spacing-base;
  display: flex;
  flex-direction: column;
  gap: $spacing-small;

  .secondary-btn-dark {
    border-color: #FFF;
    color: #FFF;
    height: 50px;
    font-size: $font-size-x-small;
  }

  .delete-btn {
    background: $sec0;
    color: $sec2;
    border: 0;
    border-radius: 0;
    font-weight: bold;
    height: 24px;
    font-size: $font-size-x-small;
    cursor: pointer;
  }
  
  button {
    width: 45%;
    i {
      display: block;
      margin-bottom: $spacing-small;
    }
  }
}
</style>